<template>
  <span
    class="bolinha-status"
    :class="cor ? 'bolinha-status--' + cor : 'bolinha-status--vazia'"
  ></span>
</template>

<script>
export default {
  name: "BolinhaStatusTratativa",

  props: {
    cor: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.bolinha-status {
  display: inline-block;
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}

.bolinha-status--vazia {
  visibility: hidden;
}

.bolinha-status--amarelo {
  background-color: rgb(222, 222, 8);
  box-shadow: rgba(222, 222, 8, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--magenta {
  background-color: rgb(255, 0, 255);
  box-shadow: rgba(255, 0, 255, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--laranja {
  background-color: rgb(240, 145, 37);
  box-shadow: rgba(240, 145, 37, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--azul {
  background-color: rgb(0, 139, 255);
  box-shadow: rgba(0, 139, 255, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--verde {
  background-color: rgb(0, 209, 0);
  box-shadow: rgba(0, 209, 0, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--vermelho {
  background-color: rgb(255, 0, 0);
  box-shadow: rgba(255, 0, 0, 0.8) 0px 0px 12px 2px;
}

.bolinha-status--cinza {
  background-color: rgb(153, 153, 153);
  box-shadow: rgba(153, 153, 153, 0.8) 0px 0px 12px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/BolinhaStatusTratativa.vue